import { HealthLang } from "../health/healthTypes";

export function educationLocalePath(path: string, lang: HealthLang): string {
    if (path.startsWith("http") || path.startsWith("mailto")) return path;
    if (lang === "Zh" && path.startsWith("/")) return `/tw${path}`;
    if (lang === "Jp" && path.startsWith("/")) return `/jp${path}`;
    return path;
}
